import { FC, useContext, useState } from 'react'
import { useRouter } from 'next/router'
import Image from 'next/image'
import clsx from 'clsx'
import Skeleton from 'react-loading-skeleton'

import LikeContext from 'context/LikeContext'
import LikeShareMenu from './like-share-menu'
import Auth from 'store/auth'

import { cutHashFromURL, preparedIdURL } from 'utils/getURLData'
import { postAxiosSingle } from 'pages/api/axios'
import { STATIC_URL } from 'constants/data'
import {
  A_sm_clickLike,
  A_sm_shareOpen,
  originShare,
} from 'utils/analytics/other/share_material/share_material'
import { URL_LIST } from 'constants/url'
import { popupName } from 'constants/auth/auth-data'

import styles from './like-share.module.scss'

const imgPath = {
  active: `${STATIC_URL}/like-share/btn_like_active.svg`,
  notActive: `${STATIC_URL}/like-share/btn_like_not_active.svg`,
  share: `${STATIC_URL}/like-share/btn_share.svg`,
}

interface ILikeShare {
  noLike?: boolean
  modificator?: string
  txtBtn?: string
  menuModificator?: string
  AData?: {
    origin: originShare
  }
}

const LikeShare: FC<ILikeShare> = ({
  noLike = false,
  modificator,
  txtBtn = 'Поделиться',
  menuModificator,
  AData,
}: ILikeShare) => {
  const router = useRouter()
  const { isAuthorized, fakeAuth } = Auth.useAuth()

  const [isShareOpened, setShareOpened] = useState(false)
  const { status, setStatus } = useContext(LikeContext)

  const path = cutHashFromURL(router.asPath)

  const handleClick = async () => {
    if (isAuthorized && !fakeAuth) {
      const data = {
        id: preparedIdURL(window.location.pathname),
        like: !status?.like,
      }
      const result = await postAxiosSingle(URL_LIST.LIKE, {}, data)
      setStatus({
        like: result.data.like,
        likeCount: String(result.data.likeCount),
      })
      AData && A_sm_clickLike(AData.origin)
    } else {
      router.push(`${path}#${popupName.registration}`, undefined, { shallow: true })
    }
  }

  const openShare = (e: React.MouseEvent<HTMLElement>) => {
    setShareOpened(true)
    AData && A_sm_shareOpen(AData.origin)
    e.stopPropagation()
  }
  const closeShare = () => setShareOpened(false)

  return (
    <div className={clsx(styles.likeShare, { [modificator as string]: modificator })}>
      {!noLike && (
        <button
          className={clsx(styles.like, {
            [styles.likeActive]: status?.like,
          })}
          onClick={handleClick}
        >
          <div className={styles.icon}>
            <Image
              src={status?.like ? imgPath.active : imgPath.notActive}
              width="30"
              height="30"
              alt={status?.like ? 'лайк поставлен' : 'поставить лайк'}
              unoptimized={true}
            />
          </div>
          <span className={styles.likeWord}>Мне нравится </span>
          {status?.likeCount ? <>&nbsp;• {status?.likeCount}</> : <Skeleton width={22} />}
        </button>
      )}
      <div className={styles.shareMenu}>
        <button className={styles.share} onClick={openShare}>
          <div className={styles.icon}>
            <Image src={imgPath.share} width="30" height="30" alt="поделиться" unoptimized={true} />
          </div>
          <span>{txtBtn}</span>
        </button>
        {isShareOpened && <LikeShareMenu setClosed={closeShare} modificator={menuModificator} />}
      </div>
    </div>
  )
}

export default LikeShare
